import DOMHelpers from '../utils/dom-helpers';
//import { debounce as _debounce } from 'es-toolkit';

export default class{

    constructor( options ) {
        this.defaults = {
            el: false,
        }
        this.options = {};
        Object.assign(this.options, this.defaults, options);
        this.namespace 		= 	'multi-select-component-filters';
        this.el 			= 	this.options.el;
        this.main			=   this.options.main;

        // DOM helpers
        this.dom = new DOMHelpers(document);

        // VARS (vanilla DOM)
        /*
        this.window = window;
        this.document = document;
        this.htmlEl = document.documentElement;
        this.body = document.body;
        */
        // convenience shorthands
        /*
        this.qs = this.dom.qs.bind(this.dom);
        this.qsa = this.dom.qsa.bind(this.dom);
        this.on = this.dom.on.bind(this.dom);
        this.off = this.dom.off.bind(this.dom);
        this.addClass = this.dom.addClass.bind(this.dom);
        this.removeClass = this.dom.removeClass.bind(this.dom);
        this.hasClass = this.dom.hasClass.bind(this.dom);
        this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);
        */

        this.selects = this.dom.qsa( '.select-component', this.el );
        this.target  = this.dom.qs( '.' + this.el.getAttribute('data-target') );
     
        if ( this.target ){
            this.targetItems =  this.dom.qsa( '.' + this.el.getAttribute('data-item'), this.target );
        }      
        
        this.init();
        
    }

    init(){
        this.addEvents( true );

        // check if one is selected
        this.onChange();
    }

    //---------------------------------------- EVENTS ---------------------------------------//
    addEvents( b ){
        if ( b ){
            this.dom.on( this.selects,'select-change', this.onChange );
        }
        else{
            this.dom.off( this.selects, 'select-change', this.onChange );
        }
    }

    onChange = () => {
        let o = {};
        this.main.setLoading( true );
        this.selects.forEach((el, i) => {
            o[ el.getAttribute( 'data-slug' ) ] = el.__widget.getValue()
        });
        this.resolveGrid( o );
    }

    resolveGrid( o ){

        //console.log( o );

        if( this.targetItems ){
            this.targetItems.forEach( (el, i) => {
                let isVisible = true;
                for( const key in o ){
                    let val = o[ key ], 
                        itemVal = el.getAttribute( key );
                    
                    // where to verify, when the select is selected ...
                    if ( val !== 'all' ){
                        // if there is no taxonomy or artist associated
                        if ( !itemVal ){
                            isVisible = false;
                        }
                        // if there is something associated but doesn't have the value selected
                        else if ( itemVal.indexOf( val ) === -1 ){
                            isVisible = false;
                        }
                    }
                }
                if ( isVisible ){
                    this.dom.removeClass( el, 'hide' );
                }
                else{
                    this.dom.addClass( el, 'hide' );
                }
            });
            this.dom.trigger( window, 'resize' );
            this.main.setLoading( false );
        }
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        
        this.addEvents( false );
        
    }

}


